export const requiredFields = [
  'name',
  'phoneNumber',
  'openingHours',
  'address',
  'city',
  'state',
  'country',
];
